import { VentaDetalle } from "./venta_detalle";
import { Cliente } from "./cliente";
import { Bodega } from "./bodega";
import { Cobro } from "./cobro";
import { Retencion } from "./retencion";
import { Caja } from "./caja";
import { Guiaremision } from "./guiaremision";
import { Amortizacion } from "./amortizacion";
import { CobroGrupo } from "./cobro-grupo";
import { AsientoContable } from "./asiento-contable";

export class Venta{
    public constructor(
        public id: String = "",
        public tipo_comprobante_id: String = "",
        public numero_documento: String = "",
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public is_secuencial_manual: boolean = false,
        public selected: boolean = false,
        public numero_autorizacion: String = "",
        public estado_pago: String = "",
        //public fecha_caducidad: String = "",
        public fecha_emision: any = "",
        //public numero_autorizacion: String = "",
        //
        public tipo: String = "CO",
        public tipo_venta: String = "menor",
        //public subtotal:number = 0,
        //Campos nuevos
        public subtotal_iva12:number = 0,
        public subtotal_iva0:number = 0,
        public desct_valor:number = 0,
        public desct_porcent:number = 0,
        public subt_desct_iva12:number = 0,
        public subt_desct_iva0:number = 0,
        //
        public iva:number = 0,
        public abonado:number = 0,
        public total: number = 0,
        public observacion: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public status: String = "",
        public mesa_id: String= "",
        public pedido_id: String= "",

        //public tipo_documento_id: String = "",
        //
        public cliente_id: String = "",
        public caja_id: String = "",
        public asignacion_caja_id:String = null,
        public bodega_id: String = "1",
        public forma_pago_facturacion_id: String = "",
        public usuario_id:String = null,
        public detalle: Array<VentaDetalle> = [],
        public cliente: Cliente = new Cliente(),
        public caja: Caja = new Caja(),

        public json_string: any = {},
        public tipocbt_select: String = "",

        //
        public tipocomprobante: any = {},
        public estadobitacora: any = {},
        public bodega: Bodega = new Bodega(),
        public cobros: Array<Cobro> = [],
        public asientosContables: Array<AsientoContable> = [],
        public retencion: Retencion = new Retencion(),
        public grupo: Array<CobroGrupo> = [],
        public guiaremision: Guiaremision = new Guiaremision(),
        public amortizacion: Amortizacion = new Amortizacion(),
        public notacredito : any ={}
        
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/venta.ts